import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import homeLogo from "../../Assets/homeLogo.jpeg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />

        <Container
          className="home-content"
          style={{
            paddingTop: "10px",
            paddingBottom: "15px",
            maxWidth: "1350px",
          }}
        >
          <Row
            className="align-items-center"
            style={{
              minHeight: "82vh",
              paddingTop: "10px",
            }}
          >
            {/* LEFT SIDE */}
            <Col lg={7} md={12} className="home-header">
              {/* Greeting */}
              <motion.h1
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                style={{
                  fontSize: "2.35rem",
                  fontWeight: "400",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Hello There{" "}
                <span className="wave" role="img" aria-label="wave">
                  👋🏻
                </span>
              </motion.h1>

              {/* Name */}
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.2 }}
                style={{
                  fontSize: "3.25rem",
                  fontWeight: "700",
                  marginBottom: "10px",
                  color: "white",
                  lineHeight: "1.1",
                }}
              >
                I'M{" "}
                <span
                  style={{
                    color: "#c770f0",
                  }}
                >
                  GAURAV KUMAR
                </span>
              </motion.h1>

              {/* Designation */}
              <motion.h2
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  delay: 0.5,
                  duration: 1,
                }}
                style={{
                  color: "#c770f0",
                  fontSize: "1.75rem",
                  fontWeight: "600",
                  marginBottom: "25px",
                }}
              >
                Software Engineer | Full Stack Developer
              </motion.h2>

              {/* Professional Summary */}
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  delay: 1,
                  duration: 1,
                }}
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.7",
                  color: "#e5e7eb",
                  maxWidth: "650px",
                  marginBottom: "25px",
                }}
              >
                Building scalable enterprise applications using{" "}
                <strong>
                  .NET, React, Microservices, Cloud and DevOps
                  technologies
                </strong>
                . Passionate about designing secure,
                high-performance distributed systems and delivering
                production-ready full-stack software solutions.
              </motion.p>

              {/* Skills */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  delay: 1.4,
                  duration: 1,
                }}
                style={{
                  marginTop: "10px",
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  color: "white",
                }}
              >
                <div>🚀 Microservices Architecture</div>
                <div>⚡ .NET & React Ecosystem</div>
                <div>☁️ Cloud & DevOps Engineering</div>
                <div>🔐 Secure Web Application Development</div>
              </motion.div>

              {/* Typing Animation */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  delay: 2,
                  duration: 1,
                }}
                style={{
                  marginTop: "15px",
                }}
              >
                <Type />
              </motion.div>
            </Col>

            {/* RIGHT SIDE */}
            <Col
              lg={5}
              md={12}
              className="text-center"
            >
              <motion.div
                initial={{
                  scale: 0.8,
                  opacity: 0,
                }}
                animate={{
                  scale: 1,
                  opacity: 1,
                }}
                transition={{
                  duration: 1.3,
                }}
              >
                <img
                  src={homeLogo}
                  alt="home"
                  className="img-fluid"
                  style={{
                    maxHeight: "390px",
                    width: "100%",
                    maxWidth: "470px",
                    objectFit: "cover",
                    borderRadius: "25px",
                    boxShadow:
                      "0 0 35px rgba(199,112,240,0.45)",
                  }}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Home2 />
    </section>
  );
}

export default Home;